module.exports = __webpack_public_path__ + "img/left.6e71609e.png";